import { render, staticRenderFns } from "./ContentPlayer.vue?vue&type=template&id=2717326e&scoped=true&"
import script from "./ContentPlayer.vue?vue&type=script&lang=js&"
export * from "./ContentPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717326e",
  null
  
)

export default component.exports